import style from './OptionQCM.module.css';

/**
 * Affiche une option QCM
 */
export function OptionQCM(props) {
    return <span style={{margin: ".5rem 1rem 0 1rem"}}><label className={style.span}><input name={"option"} className={style.input} type={props.type} ref={props.setRef}/>{props.option.text}</label></span>;
}